import library from '@/modules/library/library'

// Store functionality
import actions from '@/store/actions'
import getters from '@/store/getters'
import modules from '@/store/modules'
import mutations from '@/store/mutations'
import state from '@/store/state'
import { storePlugins } from '@/store/store-plugins'

/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */
import { createStore } from 'vuex'

modules[library.moduleName] = library

const store = createStore({
  actions,
  getters,
  mutations,
  state,
  modules,
  plugins: [storePlugins],
  // devtools enabled on the store allows the vue extension to inspect the state in Chrome
  // (develop: `Vue.config.devtools = process.env.VUE_APP_DEV_TOOLS === 'true'` before
  // `new Vuex.Store`). Dev builds keep Vuex 4's default-on behavior.
  devtools: process.env.VUE_APP_DEV_TOOLS === 'true' || process.env.NODE_ENV !== 'production',
})

export default store
